module.exports = __webpack_public_path__ + "static/media/Zocial.1681f34a.ttf";